// extracted by mini-css-extract-plugin
module.exports = {"content":"Content_content__R8dU1","contentTitle":"Content_content-title__o4Ov4","contentText":"Content_content-text__L6wDv","contentTrace":"Content_content-trace__K2zpP"};